import React from 'react';
import SafeIcon from '../common/SafeIcon';

const CARDS_DATA = [
  { icon: 'TrendingUp', title: 'Growth', desc: 'Clear career progression and development programs' },
  { icon: 'Heart', title: 'Culture', desc: 'Collaborative, inclusive, and innovative work environment' },
  { icon: 'DollarSign', title: 'Compensation', desc: 'Competitive salary packages and comprehensive benefits' },
  { icon: 'Globe', title: 'Impact', desc: 'Meaningful work that shapes industries across Ghana' },
];

const Content = () => {
  return (
    <div className="space-y-6 max-w-6xl">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Landing Page Content</h1>
          <p className="text-gray-500">Update the "Why Work Here" section and values.</p>
        </div>
      </div>

      <div className="card p-6 sm:p-8">
        <h2 className="text-lg font-bold text-gray-800 mb-8 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-[#11469A]">
            <SafeIcon name="PlusCircle" size={20} />
          </div>
          Add New Value Card
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Choose Icon</label>
            <input type="text" placeholder="e.g. Star" className="input-field" />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Card Title</label>
            <input type="text" placeholder="e.g. Innovation" className="input-field" />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Description</label>
            <input type="text" placeholder="Short value proposition..." className="input-field" />
          </div>
        </div>
        <button className="bg-[#11469A] hover:bg-[#0d3678] text-white px-10 h-11 rounded-lg font-bold text-sm transition-all shadow-sm">
          Save Card
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CARDS_DATA.map((card, index) => (
          <div key={index} className="card p-8 text-center group relative hover:border-[#11469A] border border-transparent transition-all">
            <button className="absolute top-4 right-4 p-1.5 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-all rounded-lg hover:bg-gray-50">
              <SafeIcon name="Trash2" size={16} />
            </button>
            <div className="w-16 h-16 mx-auto bg-blue-50 text-[#11469A] rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110 duration-300">
              <SafeIcon name={card.icon} size={28} />
            </div>
            <h3 className="text-gray-800 font-bold text-lg mb-3">{card.title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed font-medium">{card.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Content;